import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/presences
    */
    getPresences: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/presences',{
            params:{
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                selectedYear:options.selectedYear,
                selectedCourse:options.selectedCourse,
                selectedDay:options.selectedDay,
                selectedChild:options.selectedChild,
                showError:options.showError
        }});
    },

   
    /*
		POST 	/api/presences
	*/
    postAddNewPresence: function( child_id,day, entry,leave,present,breakfast,lunch,tea,note ){
        return axios.post( LOGUS_CONFIG.API_URL + '/presences',
            {
                child_id: child_id,
                day:day,
                entry:entry,
                leave:leave,
                present:present,
                breakfast:breakfast,
                lunch:lunch,
                tea:tea,
                note:note,
            }
        );
    },

    /*
		POST 	/api/presencesV2
	*/
    postAddNewPresenceV2: function( child_id,day, entry,leave,present,breakfast,lunch,tea,note,picking_up ){
        return axios.post( LOGUS_CONFIG.API_URL + '/presencesV2',
            {
                child_id: child_id,
                day:day,
                entry:entry,
                leave:leave,
                present:present,
                breakfast:breakfast,
                lunch:lunch,
                tea:tea,
                note:note,
                picking_up:picking_up
            }
        );
    },

    /*
		GET 	/api/presences/{slug}/edit
	*/
    getPresenceEdit: function( slug,selectedDay ){
		return axios.get( LOGUS_CONFIG.API_URL + '/presences/' + slug + '/edit',{
            params:{
                selectedDay:selectedDay
            }
        } );
	},

    /*
		PUT 	/api/presences/{slug}
	*/
    putEditPresence: function(slug, child_id,day,entry,leave,present,breakfast,lunch,tea,note,deleteNext){
        return axios.put( LOGUS_CONFIG.API_URL + '/presences/'+ slug,
            {
                child_id: child_id,
                day:day,
                entry:entry,
                leave:leave,
                present:present,
                breakfast:breakfast,
                lunch:lunch,
                tea:tea,
                note:note,
                deleteNext:deleteNext
            }
        );
    },

    /*
		PUT 	/api/presencesV2/{slug}
	*/
    putEditPresenceV2: function(slug, child_id,day,entry,leave,present,breakfast,lunch,tea,note,deleteNext,picking_up){
        return axios.put( LOGUS_CONFIG.API_URL + '/presencesV2/'+ slug,
            {
                child_id: child_id,
                day:day,
                entry:entry,
                leave:leave,
                present:present,
                breakfast:breakfast,
                lunch:lunch,
                tea:tea,
                note:note,
                deleteNext:deleteNext,
                picking_up:picking_up
            }
        );
    },
    
    /*
		DELETE /api/presences/{slug}/force
	*/
    forceDeletePresence: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/presences/' + slug + '/force' );
    },
    
    /*
        GET     /api/presences/kitchen
    */
    getKitchenSummary: function(selectedDay){
    return axios.get( LOGUS_CONFIG.API_URL + '/presences/kitchen',{
        params:{
            selectedDay:selectedDay
    }});

    },

    //########################### dashboard

    /*
        GET     /api/presences/dashboard/present
    */
   getDashboardPresent: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/presences/dashboard/present',{
        params:{
            offset:options.offset,
            itemsPerPage:options.itemsPerPage,
            orderBy:options.orderBy,
            orderDirection:options.orderDirection,
    }});

    },

     /*
        GET     /api/presences/dashboard/absent
    */
   getDashboardAbsent: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/presences/dashboard/absent',{
        params:{
            offset:options.offset,
            itemsPerPage:options.itemsPerPage,
            orderBy:options.orderBy,
            orderDirection:options.orderDirection,
    }});
    
    },

     /*
        GET     /api/presences/dashboard/nostatus
    */
   getDashboardNoStatus: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/presences/dashboard/nostatus',{
        params:{
            offset:options.offset,
            itemsPerPage:options.itemsPerPage,
            orderBy:options.orderBy,
            orderDirection:options.orderDirection,
    }});
    
    },

     /*
        GET     /api/presences/dashboard/late
    */
   getDashboardLate: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/presences/dashboard/late',{
        params:{
            offset:options.offset,
            itemsPerPage:options.itemsPerPage,
            orderBy:options.orderBy,
            orderDirection:options.orderDirection,
    }});
    
    },

    /*
		PUT 	/api/presences/absense
	*/
    putChildAbsense: function(child_id,note,noteText,from,to){
        return axios.put( LOGUS_CONFIG.API_URL + '/presences/absense',
            {
                child_id: child_id,
                note:note,
                noteText:noteText,
                from:from,
                to:to,
            }
        );
    },
}